import { Opcion } from '../../../models/catalogo.type'
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import {
  schemaRecordatorios,
  TRecordatorioForm,
} from '../../recordatorios/models/recordatorioForm.type'

export const style = {
  borderRadius: '10px',
  background: '#333',
  color: '#fff',
  fontSize: '18px',
}
export type TTareaCondicionanteForm = {
  idSitio?: string | null
  idAutorizacion?: string | null
  idCondicionante?: string | null
  idTarea?:string
  titulo: string
  descripcion: string
  idUsuarioAsignado: Opcion | null
  /**
   * No identificado en el codigo/configuracion revisada.
   * Nota: el schema de yup requiere `prioridad`, pero el tipo y el UI de condicionantes no lo usan.
   */
  prioridad?: Opcion | null
  estatus: Opcion | null
  fechaInicio: string
  fechaTermino: string
  isManual: boolean
  recordatorios?: TRecordatorioForm[] | []
}
export const schemaTareasCondicionantes = yup.object({
  tareas: yup.array().of(
    yup.object().shape({
      titulo: yup.string().trim().required('El título es requerido'),
      descripcion: yup.string().trim().required('La descripción es requerida'),
      idUsuarioAsignado: yup.object().nullable().required('El usuario es requerido'),
      // El UI actual de condicionantes no captura prioridad; si backend/negocio lo requiere,
      // faltaria el campo en el formulario. Se mantiene la regla para no cambiar comportamiento.
      prioridad: yup.object().nullable().required('La prioridad es requerida'),
      estatus: yup.object().nullable().required('El estatus es requerido'),
      fechaInicio: yup.string().nullable().required('La fecha es requerida'),
      fechaTermino: yup.string().nullable().required('La fecha es requerida'),
    })
  ),
})
const schemaConcat = schemaTareasCondicionantes.concat(schemaRecordatorios)
export const useTareaFormCondicionante = () => {
  return useForm<TTareaCondicionanteForm>({
    mode: 'all',
    resolver: yupResolver(schemaConcat),
  })
}
